import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 16px;
  margin-bottom: 16px;
`

export const DetailBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const DetailItemTitle = styled.div`
  font-size: 16px;
  color: ${myPalette.dark.main};
`

export const DetailAmountTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
`
